module.exports = __webpack_public_path__ + "img/cash_in_hand.5b5235ae.png";